export default __webpack_public_path__ + "static/media/4.7dcf9453.jpeg";